import { layouts } from '@app/shared/utils/job-utils';

export class UserPrefs {
  campaignLayoutView:string = layouts.GRID_LAYOUT;
  showOfferViews:string = null;
  projectSearchHistory:string[] = [];
  assignedToMe:boolean = false;
  showTeamOverlay:boolean = true;
  showSalesSummary:boolean = true;
  showAdditionalInfo:boolean = true;
  offerFilterFields:string[] = [];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/userPrefs.ts